import React from "react";
import { MoreVertical } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@shared/ui/dropdown-menu";
import { Button } from "@shared/ui/button";

interface UtilityActionsMenuProps {
  isActive: boolean;
  onView: () => void;
  onEdit: () => void;
  onToggleStatus: () => void;
}

const UtilityActionsMenu: React.FC<UtilityActionsMenuProps> = ({
  isActive,
  onView,
  onEdit,
  onToggleStatus,
}) => {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreVertical className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>

      <DropdownMenuContent align="end" className="w-44">
        <DropdownMenuItem onClick={onView}>View details</DropdownMenuItem>
        <DropdownMenuItem onClick={onEdit}>Edit details</DropdownMenuItem>
        <DropdownMenuItem
          onClick={onToggleStatus}
          className={isActive ? "text-red-600" : "text-green-600"}
        >
          {isActive ? "Deactivate Utility" : "Activate Utility"}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
};

export default UtilityActionsMenu;
